import { REGISTRATION_STATES } from '@repo/api-kit/queries/registration-states';
import { ROUTE_PARAMS } from '../route-params';

export const FR_EXISTING_COMPANY_INVOICING_UPSELL_MAPPING = {
  [REGISTRATION_STATES.OWNER_INFO]: {
    url: '/qonto-business-account/:organization_id/personal-info',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.OWNER_ADDITIONAL_INFO]: {
    url: '/qonto-business-account/:organization_id/legal-info',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.OWNER_POWER_GIVER]: {
    url: '/qonto-business-account/:organization_id/legal-info/representative',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.BUSINESS_ACTIVITY_ENTITY_TYPE]: {
    url: '/qonto-business-account/:organization_id/business-activity',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.COMPANY_FINANCES]: {
    url: '/qonto-business-account/:organization_id/business-info',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.COMPANY_INFO]: {
    url: '/qonto-business-account/:organization_id/business-info/legal-form',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.DECLARED_PEP_IN_BENEFICIARIES]: {
    url: '/qonto-business-account/:organization_id/business-info/beneficial-owners-pep',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.COMPANY_BENEFICIARIES]: {
    url: '/qonto-business-account/:organization_id/business-info/ubos',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.COMPANY_NATURE_OF_OPS]: {
    url: '/qonto-business-account/:organization_id/business-info/usage',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.COMPANY_CONTRACT]: {
    url: '/qonto-business-account/:organization_id/confirm',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.COMPANY_PENDING_CONTRACT_SIGN]: {
    url: '/qonto-business-account/:organization_id/pending-contract',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.COMPANY_CONTRACT_SIGNED]: {
    url: '/qonto-business-account/:organization_id/success',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
};
